import request from 'superagent';

export function getImpersonation(callback) {
  return simpleIsoFetch => (dispatch, getState) => {
    simpleIsoFetch.get('/api/auth/impersonate')
      .then(({body: {data: {items: [impersonateUser]}}}) => callback(null, impersonateUser))
      .catch(callback);
  };
}

export function resetImpersonation(impersonateId) {
  return new Promise((resolve, reject) => {
    request.post('/api/auth/impersonate')
      .set('Content-Type', 'application/json')
      .send({impersonateId})
      .end((err, res) => {
        if (!err && res.statusCode === 204) {
          return resolve();
        }

        return reject(err);
      });
  });
}

export function deleteImpersonation() {
  return new Promise((resolve, reject) => {
    request.delete('/api/auth/impersonate')
      .set('Content-Type', 'application/json')
      .send()
      .end((err, res) => {
        if (!err && res.statusCode === 204) {
          return resolve();
        }

        return reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/async/impersonation.js